import { render, staticRenderFns } from "./DataPolicy.vue?vue&type=template&id=9546674c&scoped=true&"
import script from "./DataPolicy.vue?vue&type=script&lang=js&"
export * from "./DataPolicy.vue?vue&type=script&lang=js&"
import style0 from "./DataPolicy.vue?vue&type=style&index=0&id=9546674c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9546674c",
  null
  
)

export default component.exports